<template>
  <div v-if="isLoggedIn" class="mt-1">
    <v-tabs
      v-model="active"
      color="indigo"
      centered
      dark
      slider-color="yellow"
    >
      <v-tab
        v-for="(status, index) in statuses"
        :key="index"
        ripple
        @click="statusList(status.status_id)"
      >
         {{ status.title }}
      </v-tab>
      <v-tab-item
        v-for="(status, index) in statuses"
        :key="index"
        
      >
        <v-card flat v-if="status.status_id == 0  && active == 0">
            <DasherTeamPending></DasherTeamPending>
        </v-card>
        <v-card flat v-else-if="status.status_id == 1 && active == 1">
           <DasherTeamVerified></DasherTeamVerified>
        </v-card>
        <v-card flat v-else-if="status.status_id == 2 && active == 2">
           <DasherTeamRejected></DasherTeamRejected>
        </v-card>
      </v-tab-item>
    </v-tabs>

    <!-- <div class="text-xs-center mt-3">
      <button class="button" flat @click="next">Next Tab</button>
    </div> -->
  </div>
  <div centered v-else>
    <v-container>
      <v-layout row wrap>
        <v-flex xs4 md4></v-flex>
        <v-flex xs4 md4 align-end>
          <v-card>
            <v-card-text color="indigo">
                You are not logged in!
            </v-card-text>
          </v-card>
          <router-link to="/signin">
            <v-btn color="#ff2e2e"><v-icon>lock_open</v-icon> login</v-btn>
          </router-link>
        </v-flex>
        <v-flex xs4 md4></v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import DasherTeamPending from './DasherTeamPending'
import DasherTeamVerified from './DasherTeamVerified'
import DasherTeamRejected from './DasherTeamRejected'

import {mapGetters} from 'vuex'

  export default {
    data () {
      return {
        active: null,
        statuses:[
          {'title': 'pending', 'status_id': 0}, 
          {'title': 'verified', 'status_id': 1},
          {'title': 'rejected', 'status_id': 2},
        ]
      }
    },
    components: {
      DasherTeamPending,
      DasherTeamVerified,
      DasherTeamRejected
    },
    computed:{
      ...mapGetters(['isLoggedIn', 'indexData', 'error', 'statusCode', 'errorMsg'])     
    },

    created () {
      this.statusList(0)
    },

    methods: {
      next (status) {
        // const active = parseInt(this.active) 
        // console.log(status);   
        this.statusList(status);
        this.active = parseInt(status); 
        // this.active = (this.active < 2) ? this.active + 1 : 0     
      },     
      statusList: function(teamStatusId){
        this.$store.dispatch('changeDasherTeamStatus', ['team-response-status', teamStatusId, "", 1, 5,])
      }
    }
  }
</script>

<style lang="stylus" scoped>
.button {
  font-size: 16px;
  background: #ff2e2e;
  padding: 0.4rem 1.3rem;
  text-align: center;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  margin: 10px;
  color:white;
}
  
</style>